/**
 * Frequently Asked Questions module.
 * All Faq functionality.
 *
 * @module feature/Faq
 */
import 'bootstrap/js/dist/collapse.js';
import QueryStringHandler from 'QueryStringHandler';

/**
 * Question/answer collapse functionality and updates URL.
 *
 * @requires bootstrap/js/dist/collapse
 * @requires module:project/Common.QueryStringHandler
 * @memberOf module:feature/Faq
 * @version 1.0.0
 * @author Rocco Janse <rocco.janse@valtech.nl>
 */
class Faq {
    /**
     * Sets up collapsibles of FAQ's and captures URL hash, if there is any.
     * @param {jQueryElement} $element DOM Element to be upgraded.
     */
    constructor($element) {
        this.$element = $($element);
        this.$collapseParents = this.$element.find('.collapsible');
        this.collapsibles = [];

        // get querystring hash
        this.qsHash = unescape(
            QueryStringHandler.getHash(QueryStringHandler.getQueryString()).substr(1).replace(/-/g, ' ')
        );
    }

    /**
     * Initializes collapsibles and adds events.
     */
    init() {
        // init collapses
        this.$collapseParents.each((i, parent) => {
            const $parent = $(parent);

            this.collapsibles.push({
                $trigger: $parent.find('.collapse-trigger'),
                $collapsible: $parent.find('.collapse').collapse('hide'),
            });

            this.collapsibles[i].$collapsible.on('show.bs.collapse', () => {
                this.collapsibles[i].$trigger.addClass('is-active');
            });
            this.collapsibles[i].$collapsible.on('hidden.bs.collapse', () => {
                this.collapsibles[i].$trigger.removeClass('is-active');
            });

            // show if in querystring
            if (this.qsHash && this.collapsibles[i].$trigger.text().trim() === this.qsHash) {
                this.collapsibles[i].$collapsible.collapse('show');
            }

            // events
            this.collapsibles[i].$trigger.on('click.collapsible', (e) => {
                for (let i = 0; i < this.collapsibles.length; i++) {
                    this.collapsibles[i].$collapsible.collapse('hide');
                }
                this.collapsibles[i].$collapsible.collapse('toggle');
                QueryStringHandler.updateUrl('', escape($(e.currentTarget).text().trim().replace(/ /g, '-')));
            });
        });
    }
}

// register to Component Handler
window.ComponentHandler.register({
    constructor: Faq,
    classAsString: 'Faq',
    cssClass: 'js-faq',
});

export default Faq;
